import router from './router'
import store from './store'
import { getUserInfo } from '@/utils/user-info' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission (roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}
// no redirect whitelist
const whiteList = [
  '/login',
  '/authredirect',
  '/register',
  '/forgetpsw',
  '/resetpassword',
  '/courseselect',
  '/courseselect/index',
  '/teacheractive',
  '/freecoursePlay',
  '/appExamWebView',
  '/teacherresetpassword',
  '/thirdpartyloginredirect']
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getUserInfo()) { // determine if there has token
    /* has token */
    if (!store.getters.userInfoGetted) {
      store.commit('SET_USER_INFO', getUserInfo())
    }
    // 如果不属于咨询相关人员，则登出
    if (!store.getters.isChannelUserOrAdmin) {
      store.dispatch('FedLogOut').then(() => {
        next({ path: '/' })
      })
      return
    }
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger afterEach hook, so manually handle it
    } else {
      if (!store.getters.userDetailInfoGetted) { // 判断当前用户是否已拉取完详细信息
        store.dispatch('GetUserDetailInfo').then(() => { // 拉取详细信息
          store.dispatch('GenerateRoutes', {
            roles: store.getters.roles
          }).then(() => { // 根据roles权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            // Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (hasPermission(store.getters.roles, to.meta.roles)) {
          next()//
        } else {
          next({path: '/401', replace: true, query: { noGoBack: true }})
        }
        // 可删 ↑
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      next('/login') // 否则全部重定向到登录页
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js